/**
 * Canon
 *
 * @package     mcb-front-end
 * @project     Ignite
 * @description Core actions to save the token payload
 *
 */

// -------------------------------------
//   Dependencies: core
// -------------------------------------
import * as actionTypes from './actionTypes'

/**
 * @name  setAuth
 * @desc  Set the stores auth details
 */
export const setAuth = payload => {

    return dispatch => {
        //[mh] RITM0247221: the store used to guard against overwriting an existing auth object, but
        // redux-persist now rehydrates the previous session's slice (an empty object after logout) on
        // /callback, which made the guard swallow the fresh token payload and leave the SSO waiting.
        dispatch(saveAuth(payload))
    }
}
/**
 * @name  saveAuth
 * @desc  Dispatch the payload to the store
 */
export const saveAuth = payload => {

    return {
        type: actionTypes.UPDATE_AUTH,
        auth: payload
    }
}

/**
 * @name  isAuthenticating
 * @desc  Method to set the isAuthenticating state of "auth" redux state used by AuthService
 */
export const isAuthenticating = flag => {
    return (dispatch, getState) => {
        dispatch(() => ({
            type: actionTypes.IS_AUTHENTICATING,
            flag
        }))
    }
}
